/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import StyledProps from '../common/theme/AppThemeInterface';

const AuthGridWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};

  .auth__logo {
    height: 40px;
    z-index: 999;
    margin-left: calc(50% - 62px);
    position: absolute;
    top: 67.5%;
  }

  .auth__motif {
    min-height: 280px;
    width: 100%;
    height: auto;
    position: relative;

    left: 0;
    margin-bottom: -4px;
  }

  .auth__motif__container {
    z-index: 0;
    width: 100vw;
    min-height: 280px;
  }
  .auth__bg {
    width: 100%;
    text-align: right;
    height: 100%;
    position: absolute;
    bottom: 0;
    background-color: ${({ theme }: StyledProps) => theme.authBackgroundColor};
  }
`;

export default AuthGridWrapper;
